// extracted by mini-css-extract-plugin
export default {"container":"style_container__qGKjm","headerIcon":"style_headerIcon__KDtV5","forms":"style_forms__W3PI1","header":"style_header__ymwQv","body":"style_body__n0mw8"};